import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateFinixCardRequestSchema,
  TCreateFinixCardResponseSchema,
} from "./createFinixCard.schema";

export const createFinixCard = (axios: IAxiosInstance) => {
  return async (body: TCreateFinixCardRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateFinixCardResponseSchema>
    >(`/api/business-cards/card`, body);

    return response.data;
  };
};
